import { render, staticRenderFns } from "./FormSubmit.vue?vue&type=template&id=a0b4ede8"
import script from "./FormSubmit.vue?vue&type=script&lang=js"
export * from "./FormSubmit.vue?vue&type=script&lang=js"
import style0 from "./FormSubmit.vue?vue&type=style&index=0&id=a0b4ede8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports